import {ReactNode} from 'react';
import clsx from 'clsx';

interface PlayableMediaGrid {
  className?: string;
  fullWidht?: boolean;
  children: ReactNode;
}
export function ContentGrid({children, className, fullWidht}: PlayableMediaGrid) {
  return (
    <div
      className={clsx(
        'content-grid grid gap-18', 
        !fullWidht ? 'grid-cols-[repeat(var(--nVisibleItems),minmax(0,1fr))]' : '',
        className
      )}
    >
      {children}
    </div>
  );
}
